<template>
  <div v-if="retroactive" class="min-h-20">
    <span class="block text-sm">Datum terugwerkende kracht</span>
    <slot name="subtitle" />
    <div class="absolute pr-5">
      <InputDatepicker v-model="retroactiveDate" ref="inputDatepicker" />
    </div>
  </div>
  <label v-else @click="onChooseRetroactive" class="cursor-pointer space-x-2">
    <InputCheckbox v-model="retroactive" @input="onChooseRetroactive" />
    <span class="text-sm">{{ priceLabel }} met terugwerkende kracht doorvoeren</span>
  </label>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from "vue"
import InputDatepicker from "@/components/inputs/input_datepicker/InputDatepicker.vue"
import moment, { type Moment } from "moment"
import InputCheckbox from "@/components/inputs/InputCheckbox.vue"

const retroactiveDate = defineModel<Moment>({ required: true })

const props = defineProps<{
  priceType: "purchase" | "sale"
}>()

const priceLabel = computed(() =>
  props.priceType === "purchase" ? "Inkoopprijzen" : "Verkoopprijzen"
)

const retroactive = ref(false)

watch(retroactiveDate, (val) => {
  if (!val) {
    retroactive.value = false
  }
})

function onChooseRetroactive() {
  retroactive.value = true
  retroactiveDate.value = moment().startOf("day")
  nextTick(() => {
    inputDatepicker.value!.openMenu()
  })
}

const inputDatepicker = ref()
</script>

<style scoped></style>
